import r from "styled-components";
import { SkeletonShared as t } from "./atoms-v21000.js";
const l = r(t)`
  background-color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.colors.skeleton.bkg")};
  height: ${({ $height: o }) => o};
  margin: 0 auto;
  width: ${({ $width: o }) => o};
`;
export {
  l as Skeleton
};
